<template>
  <div>
    <section>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="tgName" name="0"></el-tab-pane>
      <el-tab-pane :label="jcName" name="1"></el-tab-pane>
      <el-tab-pane :label="cjName" name="2"></el-tab-pane>
    </el-tabs>
    <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
        <el-form :inline="true" :model="condition">
          <el-form-item class="form-class">
            <el-input v-model="condition.couponName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" v-on:click="getFilterList">查询</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-button type="default" @click="reset()">重置</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-select v-model="condition.couponType" placeholder="请选择" @change="getFilterList">
              <el-option
                v-for="item in CouponTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-class">
            <el-select v-model="condition.sort" placeholder="请选择" @change="getFilterList">
              <el-option
                v-for="item in allOrderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" style="padding-bottom: 5px" >
        <el-table ref="allTable" stripe align="left" v-if="showTable" :data="tableDate" highlight-current-row v-loading="loading"
                  style="width: 100%;" >
            <el-table-column  type="selection"  width="55"></el-table-column>
            <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
             <el-table-column align="center" prop="createTime" label="创建时间"  min-width="40%"></el-table-column>
            <el-table-column align="center" prop="merchantName" label="发券商户" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="hotFlg" label="热门" :formatter="formatHotFlg" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="banlanceCount" label="库存" min-width="20%"></el-table-column>
            <el-table-column align="center"  label="领取" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCouponCollection(scope.$index, scope.row)">{{scope.row.getNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="couponStatus" label="核销" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCheckCoupon(scope.$index, scope.row)">{{scope.row.useNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  label="操作" width="120" class="button-bar" fixed='right'>
              <template slot-scope="scope">
                <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
              </template>
          </el-table-column>
          <el-table-column v-if="activeName=='0'" label="必出" width="120" class="button-bar" fixed='right'>
            <template slot-scope="scope">
              <el-switch active-color="#409eff" inactive-color="#909399" v-model="scope.row.biZhong" @change="changeBizhong(scope.$index,scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>

      </el-col>
      <el-col>
          <el-table stripe align="left" v-if="showEx" :data="tableDate" highlight-current-row v-loading="loading"
                  style="width: 100%;" >
            <el-table-column align="center" prop="getTime" label="领取时间" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="nickname" label="领券人" min-width="20%"></el-table-column>
            <el-table-column prop="avatar" label="头像" width="150">
              <template slot-scope="image">
                          <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                      </template>
            </el-table-column>
            <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="couponCode" label="券码" min-width="20%"></el-table-column>
            <el-table-column  label="操作" width="120" class="button-bar" fixed='right'>
              <template slot-scope="scope">
                <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
              </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="margin-top:10px">
          <el-button v-show="activeName =='0'" type="primary" @click="cancelDraw()">取消抽奖推广</el-button>
          <el-button v-show="activeName =='1'" type="default" @click="addDraw()">抽奖推广</el-button>
      </el-col>
      <el-col :span="24" class="toolbar" style="margin-top:10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page=currentPage
          :page-sizes="[10, 20, 30, 40]"
          :page-size=pageSize
          layout="total, sizes, prev, pager, next, jumper"
          :total=total>
        </el-pagination>
      </el-col>

    <Dialog  v-if="isShow" :propsData="propsData" :showAudit="'0'" ref="dia" @fatherMethod="getList()"></Dialog>
    </section>
  </div>
</template>

<script>
   import {CouponOptions} from '../details/detail-data.js'
  import Dialog  from '../coupon/couponDetail.vue'
  export default {
    name: "coupon",
    components: {
      Dialog
    },
    data() {
      return {
        activeName:'0',
        tgName:"抽奖池",
        jcName:"奖品池",
        cjName:"抽奖记录",
        loading:false,
        condition:{
            couponName:"",
            couponType:"",
            orderType:""
        },

        showTable:false,

        isShow:false,
        showEx:true,

        values: [],
        options: CouponOptions.data,
        create_end_date: '结束日期',
        create_start_date: '开始日期',
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        userId: null,
        userName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        timeInterval: '',
        CouponTypes:[{ label: '全部', value: 0 }, { label: '代金券', value: 1 }, { label: '免单卡', value: 2 }],
        allOrderOptions:[ { label: '综合排序', value: 'banlanceCount desc,getNum desc,useNum desc,createTime desc' },
                          { label: '库存数量', value: 'banlanceCount desc' },
                          { label: '领取数量', value: 'getNum desc' },
                          { label: '核销数量', value: 'useNum desc' },
                          { label: '创建时间', value: 'createTime desc' },
                          ],
        checkStatuss:[{ label: '未审核', value: 1 }, { label: '审核未通过', value: 2 }, { label: '审核通过', value: 3 }],
        propsData:{},
        hotFlags:[{ label: '-', value: 0 }, { label: '显示', value: 1 }]
      }
    },
    created() {
      this.getCouponDrawCount();
      this.getFilterList();
    },
    methods: {
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },
      formatCouponType(row, column){
        let temp = this.CouponTypes.filter((item) => {
					return item.value == row.couponType;
				})
				return temp[0].label;
      },
      formatCheckStatus(row, column){
        let temp = this.checkStatuss.filter((item) => {
					return item.value == row.checkStatus;
				})
				return temp[0].label;
      },
      formatHotFlg(row, column){
        let temp = this.hotFlags.filter((item) => {
					return item.value == row.hotFlag;
				})
				return temp[0].label;
      },
      handleClick(tab, event){
        this.getList(1);
      },
      //全部
      getFilterList(){
        debugger
        this.currentPage = 1;
				this.getList(this.currentPage);
      },
      handleSizeChange(val){
        this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
      },
      handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
      },
      async getList(index) {
				try{
          this.showTable=false;
          this.showEx = false;
          let url ='';
          this.condition.currentPage = index;
          this.condition.pageSize = this.pageSize;
          if(this.activeName =='0' ){
            this.condition.drawFlag = 1
            url = '/draw/getDrawCouponFool';
          }else if(this.activeName =='1'){
            this.condition.drawFlag = 0
            url = '/draw/getDrawCouponFool';
          } else if(this.activeName =='2'){
            url = '/draw/getDrawRecord';
          }
          
					this.loading = true;
          
					let result = await this.$http.post(this,url, {},this.condition);
          debugger
					if (result && result.code == 200) {
						this.tableDate = result.data.rows;
						this.total = result.data.total;
						this.loading = false;
					}
          if(this.activeName =='0' ){
              this.showTable=true;
          }else if(this.activeName =='1'){
              this.showTable=true;
          } else if(this.activeName =='2'){
              this.showEx = true;
          }
				} catch(e){
					this.loading = false;
				}
			},
      resetAll(){
           this.condition.couponName='';
           this.condition.orderType="";
           this.condition.couponType= "";
      },
    
      //领取列表
      handleCouponCollection(index,row){
         this.$router.push({ path: '/draw/randomDraw/operateCouponCollection', query: { couponId: row.id,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,getNum:row.getNum} });      },
      handleCheckCoupon(index,row){
          this.$router.push({ path: '/draw/randomDraw/operateCouponCheck', query: { couponId: row.id,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,useNum:row.useNum} });
      },

      handleCouponDetail(index,row){
        this.propsData ={};
        this.propsData.userId =  this.userId;
        this.propsData.couponId = row.couponId;
        this.isShow =true;
      },
     
      async cancelDraw(){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.drawFlag = 0;
              let result = await this.$http.post(this,'/draw/setCouponDrawFlag', {},condition);
              
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getCouponDrawCount();
                    this.getList(1);
					    }
          }
      },
      async addDraw(){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.drawFlag = 1;
              let result = await this.$http.post(this,'/draw/setCouponDrawFlag', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getCouponDrawCount();
                    this.getList(1);
					    }
          }
      }, 
      async changeDraw(index,row){
        let condition={};
        condition.couponId = row.couponId;
        condition.drawFlag = row.drawFlag;
        let result = await this.$http.post(this,'/draw/setCouponDrawFlag', {},condition);
        console.info(result)
      },
      async getCouponDrawCount(){
          let condition={};
          condition.type = this.activeName;
          let result = await this.$http.post(this,'/draw/getCouponDrawCount', {},condition);
          if (result && result.code == 200) {
              this.tgName = "抽奖池（" + result.data.obj.drawCount +"）";
              this.jcName = "奖品池（" + result.data.obj.canDrawCount +"）";
              this.cjName = "抽奖记录（" + result.data.obj.historyCount +"）";
					}
      },
      async changeBizhong(index,row){
          let condition ={};
          condition.couponId=row.couponId;
          condition.biZhong =row.biZhong?"1":"0";
          debugger
          await this.$http.post(this,'/draw/setBiZhong', {},condition);
      },
      
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }


  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
